import { render, staticRenderFns } from "./TipoServicoPadrao01.vue?vue&type=template&id=2efa7b27&"
import script from "./TipoServicoPadrao01.vue?vue&type=script&lang=js&"
export * from "./TipoServicoPadrao01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports